import { Component, Input, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TypeAdresse } from '../models/TypeAdresse';
import { Step5 } from '../../../../shared/models/component-messages/diveAT/step5';
import { AutoCompleteService } from '../../../../shared/services/auto-complete.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-type-adresse',
  templateUrl: './type-adresse.component.html'
})
export class TypeAdresseComponent implements OnInit, OnDestroy, AfterViewInit {

  @Input() uid = '';
  public current_uid = 'TypeAdresse';
  @Input() parentForm: FormGroup;
  @Input() adr: TypeAdresse;
  @Input() disabled: boolean;
  @Input() rule = '';

  public step5 = new Step5();
  public paysCtrlName = '';
  public optionsSelect: any[];
  public optionsSelectType = 'PAYS';
  private destroy$ = new Subject<void>();

  constructor(private autoCompleteService: AutoCompleteService) {
  }

  public ngOnInit() {
    this.optionsSelect = this.autoCompleteService.getOptions(this.optionsSelectType);
    this.paysCtrlName = this.getUid() + '_SepAtt_pays';

    if (!this.adr) {
      this.adr = new TypeAdresse();
    }
    if (this.adr.pays === null || this.adr.pays === 'FR') {
      this.adr.pays = '';
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      const control = this.parentForm.get(this.paysCtrlName);
      if (control) {
        control.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(value => {
          if (this.adr) {
            this.adr.pays = value;
          }
        });
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }


  public getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }

  isFr() {
    return this.parentForm.controls[this.paysCtrlName]?.value === '' || this.parentForm.controls[this.paysCtrlName]?.value === null || this.parentForm.controls[this.paysCtrlName]?.value === 'FR';
  }
}
